var map = {
	"./abg-0.png": 87194,
	"./abg-1.png": 50215,
	"./abg-10.png": 97358,
	"./abg-2.png": 75536,
	"./abg-3.png": 77422,
	"./abg-4.png": 64082,
	"./abg-5.png": 19246,
	"./abg-6.png": 63231,
	"./abg-7.png": 8233,
	"./abg-8.png": 62843,
	"./abg-9.png": 84288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26615;